export const core = {
  onError: {
    title: 'Error al cargar los juegos',
    description: 'Por favor, intenta nuevamente',
    button: 'Reintentar',
  },
  games: {
    title: 'Juegos de Casino',
    description: 'No se encontraron juegos',
    findGames: 'juegos encontrados',
    suggestedTitle: 'Te pueden gustar',
  },
  grid: {
    noGames: 'No se encontraron juegos',
    tryFilters: 'Intenta ajustar los filtros para ver más resultados',
    allGames: 'Has visto todos los juegos disponibles',
  },
};
